import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { store } from './store/store';
import { Provider } from 'react-redux';
import { BrowserRouter  } from 'react-router-dom';
import { applyInterceptors } from 'api/root';
import { LDProvider } from 'launchdarkly-react-client-sdk';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

// Apply interceptors before rendering the app
applyInterceptors(store)

root.render(
  <StrictMode>
    <LDProvider clientSideID={process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID || ""}>
      <Provider store={store}>
        <BrowserRouter >
          <App />
        </BrowserRouter >
      </Provider>
    </LDProvider>
  </StrictMode>
);
